export type AppDraftErrors = { name: boolean };

export function appDraftErrors(name: string): AppDraftErrors {
  return { name: !name.trim() || name.length > 120 };
}

export function containsProjectQuery(value: string, query: string): boolean {
  const held = query.trim().toLocaleLowerCase();
  return !held || value.toLocaleLowerCase().includes(held);
}
